import { AppAPI } from './services/appAPI';
import { Products } from './services/products';

/**
 * The configuration of the `common` plugin/module.
 * @param {Aurelia} aurelia The application information.
 */
export const configure = (aurelia) => {
  // Services
  aurelia.container.registerSingleton('appAPI', AppAPI);
  aurelia.container.registerSingleton('products', Products);
};
